import cn from "classnames";
import { FileField } from "components/shared/form";
import { createRequestForUploadFile } from "helpers/form";
import React, { useState } from "react";

export default function UploadSigningFiles(props) {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});

    const saveData = (e) => {
        e.preventDefault();
        setLoading(true);
        const { stamp, signature } = data;
        const paramsRequest = createRequestForUploadFile();
        if (signature) {
            paramsRequest.body.append("signature", signature);
        }
        if (!props.onlySignature && stamp) {
            paramsRequest.body.append("stamp", stamp);
        }
        if (props.id) {
            paramsRequest.body.append("id", props.id);
        }
        props.action(paramsRequest).then((res) => {
            setLoading(false);
            if (res) {
                props.refreshData();
                props.back();
            }
        });
    };

    const renderFileField = (name, fieldProps = {}) => {
        const value = data[name];
        const onFieldChange = ({ value }) => setData({ ...data, [name]: value });
        return (
            <FileField
                inputProps={{ name }}
                value={value}
                onChange={onFieldChange}
                {...fieldProps}
                accept="image/png,image/webp"
            />
        );
    };
    return (
        <form className={cn({ loading })} onSubmit={saveData}>
            {!props.onlySignature && renderFileField("stamp", { label: "Печать" })}
            {renderFileField("signature", { label: "Подпись" })}
            <button className="btn btn-sm btn-brand float-right" type="submit">
                Сохранить
            </button>
        </form>
    );
}
